import { useState, useEffect } from "react";

const ImageOrVideo = ({
  topic,
  toolColor,
  imageUrl,
  videoUrl,
  isLoading = false,
  resolution = "original",
  createdAt,
}: {
  topic?: string;
  toolColor?: string;
  imageUrl?: string;
  videoUrl?: string;
  isLoading?: boolean;
  resolution?: "high" | "medium" | "original";
  createdAt?: string;
}) => {
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const [sources, setSources] = useState({ image: "", video: "" });

  const getResolutionUrl = async (
    url: string | undefined,
    type: "image" | "video",
  ) => {
    // Return early if no URL is provided
    if (!url) return "";

    // Return original URL for legacy content or when original resolution is requested or the created at and current time difference is less than 2 minutes
    if (
      !createdAt ||
      new Date(createdAt).getTime() < new Date("2025-02-24").getTime() ||
      Date.now() - new Date(createdAt).getTime() < 2 * 60 * 1000 ||
      resolution === "original"
    ) {
      // console.log("returning original url", url);
      return url;
    }

    // const checkUrlExists = async (checkUrl: string) => {
    //   try {
    //     const response = await fetch(checkUrl);
    //     return response.ok;
    //   } catch {
    //     return false;
    //   }
    // };

    const extension = type === "video" ? ".mp4" : /\.(jpg|jpeg|png|webp)$/;
    const resolutionUrl = url.replace(
      extension,
      `_${resolution}${type === "video" ? ".mp4" : ".$1"}`,
    );

    // return (await checkUrlExists(resolutionUrl)) ? resolutionUrl : url;
    return resolutionUrl;
  };

  useEffect(() => {
    // console.log("imageUrl", imageUrl);
    // console.log("videoUrl", videoUrl);
    // console.log("resolution", resolution);
    Promise.all([
      getResolutionUrl(imageUrl, "image"),
      getResolutionUrl(videoUrl, "video"),
    ]).then(([imageSource, videoSource]) => {
      setSources({ image: imageSource, video: videoSource });
    });
  }, [imageUrl, videoUrl, resolution]);

  const gradientClasses =
    toolColor === "purple"
      ? `absolute inset-0 bg-gradient-to-br from-purple-400/60 via-amber-500/40 to-purple-600/60 bg-blend-soft-light backdrop-blur-[2px] rounded-xl flex items-center justify-center p-4 shadow-lg shadow-purple-500/10`
      : `absolute inset-0 bg-gradient-to-br from-${toolColor}-400/60 via-purple-500/40 to-${toolColor}-600/60 bg-blend-soft-light backdrop-blur-[2px] rounded-xl flex items-center justify-center p-4 shadow-lg shadow-${toolColor}-500/10`;

  if (videoUrl) {
    return (
      <div className="relative w-full h-full">
        {imageUrl && isVideoLoading && (
          <img
            src={imageUrl?.includes("maxresdefault") ? imageUrl : sources.image}
            alt="Lesson Visual"
            className="absolute w-full h-full object-cover rounded-xl mx-auto"
          />
        )}
        <video
          src={sources.video}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover rounded-xl mx-auto"
          onPlaying={() => setIsVideoLoading(false)}
        />
      </div>
    );
  }

  return (
    <div className="relative w-full h-full">
      {(sources.image || imageUrl?.includes("maxresdefault")) && (
        <img
          src={imageUrl?.includes("maxresdefault") ? imageUrl : sources.image}
          alt="Lesson Visual"
          className="w-full h-full object-cover rounded-xl mx-auto"
        />
      )}
      {isLoading && (
        <div className={`${gradientClasses} z-10`}>
          <span className="text-white font-bold text-xl text-center drop-shadow-lg">
            {topic || "Loading..."}
          </span>
        </div>
      )}
    </div>
  );
};

export default ImageOrVideo;
